import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { AtividadeAlunoComponent } from './atividade-aluno.component';
import { CadastrarAtividadeAlunoComponent } from './cadastrar-atividade-aluno/cadastrar-atividade-aluno.component';


const routes: Routes = [
  { path: 'atividadealuno/cadastrar', component: CadastrarAtividadeAlunoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.MATRICULA_ATIVIDADE_ACOES_GERENCIAIS}  },
  { path: 'atividadealuno', component: AtividadeAlunoComponent, canActivate: [AuthGuard] ,resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.MATRICULA_ATIVIDADE_ACOES_GERENCIAIS} },
  { path: 'menu-sap/atividadealuno/cadastrar', component: CadastrarAtividadeAlunoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.MATRICULA_ATIVIDADE_SAP } },
  { path: 'menu-sap/atividadealuno', component: AtividadeAlunoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.MATRICULA_ATIVIDADE_SAP } },
  { path: 'menu-pedagogico/atividadealuno/cadastrar', component: CadastrarAtividadeAlunoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.MATRICULA_ATIVIDADE_ALUNO_PEDAGOGICO } },
  { path: 'menu-pedagogico/atividadealuno', component: AtividadeAlunoComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.MATRICULA_ATIVIDADE_ALUNO_PEDAGOGICO } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AtividadeAlunoRoutingModule { }
